import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import EphemeList from "../../Component/EphemeList";
import Filters from "../../Component/Filters/Filters";
import Tabs from "../../Component/Tabs/Tabs";
import useIsMobile from "../../Hook/mobile";
import useUser from "../../Hook/user";
import Content from "../Content";
import Footer from "../Footer";
import Header from "../Header";
import Main from "../Main";
import MenuMobile from "../MenuMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faHeart, faStar } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useParams } from "react-router";
import { changePageTitle, getSearchParams } from "../../utils";
import { displayPopin } from "../../Hook/popins";
import { api_postValueOrErrorMessage } from "../../Api/util";
import { ephemesInformations } from "../../Api/types";
import { api_getSingleEphemeInformation } from "../../Api/epheme";

function Home() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const user = useUser();

  useEffect(() => {
    setTimeout(() => {
      if (location.pathname.startsWith("/media") ||location.pathname.startsWith("/visionnage")) {
        let id = location.pathname.split("/")[2]; //get epheme ID;
        api_getSingleEphemeInformation(id).then((e) => {
          if (!e) return;
          displayPopin()("viewer", { current: e, list: [e] });
        });
      }
      let sp = getSearchParams(location.search);
      if (sp.popin) {
        displayPopin()(sp.popin, sp);
      }
      if (sp.subscriptionPopin) {
        displayPopin()("subscribe", sp);
      }
    }, 500);
  }, [location]);

  return (
    <>
      <Header />
      <Content>
        <Main>
          <h2 className="text-2xl px-4 text-center [&>*]:text-primary">
            <FormattedMessage id="snapstory__photo_video" />
          </h2>
          <Filters noOnlineFilter />
          <div className=" max-w-5xl w-full m-auto my-0 flex flex-col gap-8">
            <Tabs
              onSelect={(index) => {
                if (user?.informations?.type !== "guest")
                  localStorage.setItem("home-select", String(index));
              }}
              defaultIndex={
                user?.informations?.type !== "guest"
                  ? localStorage.getItem("home-select")
                    ? Number(localStorage.getItem("home-select"))
                    : 1
                  : 0
              }
              tabs={[
                user?.informations?.type !== "guest" && (
                  <div className="flex items-center justify-center gap-2">
                    <FontAwesomeIcon icon={faHeart} />
                    <FormattedMessage id="snapstory__title" />
                  </div>
                ),
                <div className="flex items-center justify-center gap-2">
                  <FontAwesomeIcon icon={faStar} />
                  <FormattedMessage id="snapstory__most_liked" />
                </div>,
                <div className="flex items-center justify-center gap-2">
                  <FontAwesomeIcon icon={faClock} />
                  <FormattedMessage id="snapstory__most_newest" />
                </div>,
              ]}
            >
              {user?.informations?.type !== "guest" && (
                <EphemeList endpoint="followed_feed" />
              )}
              <EphemeList
                additionalInputs={{
                  sort: "popularity",
                  types: ["classic"],
                  type: "classic",
                }}
              />
              <EphemeList
                additionalInputs={{
                  sort: "date",
                  types: ["classic"],
                  type: "classic",
                }}
              />
            </Tabs>
          </div>
        </Main>
      </Content>
      <Footer />
      <MenuMobile />
    </>
  );
}

export default Home;
